module.exports = __webpack_public_path__ + "static/media/sponsor_logo1.67a25fe0.svg";